package one.healthium.domain.paywall.models

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonNames

@OptIn(ExperimentalSerializationApi::class)
@Serializable
@SerialName("flo_control_benefits")
data class PaywallMainPlansView(
    @JsonNames("id") override val id: String,
    @SerialName("config") val config: ProductControlConfig,
) : PaywallScreenView
